import { render, staticRenderFns } from "./churnRate.vue?vue&type=template&id=2b4383f2&scoped=true"
import script from "./churnRate.vue?vue&type=script&lang=js"
export * from "./churnRate.vue?vue&type=script&lang=js"
import style0 from "./churnRate.vue?vue&type=style&index=0&id=2b4383f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b4383f2",
  null
  
)

export default component.exports